import { render } from "./StartBlock.vue?vue&type=template&id=2338b1e3&scoped=true"
import script from "./StartBlock.vue?vue&type=script&lang=js"
export * from "./StartBlock.vue?vue&type=script&lang=js"

import "./StartBlock.vue?vue&type=style&index=0&id=2338b1e3&scoped=true&lang=scss"

import exportComponent from "/home/xpixel/htdocs/xpixel.ru/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2338b1e3"]])

export default __exports__